// extracted by mini-css-extract-plugin
export default {"workingHoursWrapper":"ServiceList_workingHoursWrapper__WzhCU","workingHours":"ServiceList_workingHours__Wp5eT"};